// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YY5E"};